"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalDialogComponentsSchema = void 0;
exports.renderComponent = renderComponent;
const react_1 = __importDefault(require("react"));
const types_1 = require("../types");
const dialog_1 = require("../../../buttons/common/royalty/dialog");
const dialog_2 = require("../../../buttons/common/transfer/dialog");
const dialog_3 = require("../../../buttons/common/eth-add/dialog");
const dialog_4 = require("../../../buttons/common/eth-remove/dialog");
const dialog_5 = require("../../../buttons/hierarchy/contract/mint/dialog");
const dialog_6 = require("../../../buttons/extensions/grant-role/dialog");
const dialog_7 = require("../../../buttons/tokens/erc20/deploy/dialog");
const form_1 = require("../../../pages/hierarchy/erc20/contract/form");
const dialog_8 = require("../../../buttons/hierarchy/contract/allowance/dialog");
const form_2 = require("../../../pages/hierarchy/native/contract/form");
const form_3 = require("../../../pages/hierarchy/erc721/contract/form");
const dialog_9 = require("../../../buttons/tokens/erc721/deploy/dialog");
const dialog_10 = require("../../../buttons/hierarchy/contract/set-base-token-uri/dialog");
const dialog_11 = require("../../../buttons/integrations/chain-link/set-subscription/dialog");
const account_1 = require("../../account");
const form_4 = require("../../../pages/hierarchy/erc721/template/form");
const pages_1 = require("../../../pages");
const form_5 = require("../../../pages/hierarchy/erc998/contract/form");
const dialog_12 = require("../../../buttons/tokens/erc998/deploy/dialog");
const form_6 = require("../../../pages/hierarchy/erc998/template/form");
const view_1 = require("../../../pages/hierarchy/erc998/token/view");
const withdraw_dialog_1 = require("../../../pages/hierarchy/erc998/token/withdraw-dialog");
const form_7 = require("../../../pages/hierarchy/erc998/composition/form");
const view_2 = require("../../../pages/hierarchy/erc998/composition/view");
const form_8 = require("../../../pages/hierarchy/erc1155/contract/form");
const dialog_13 = require("../../../buttons/tokens/erc1155/deploy/dialog");
const form_9 = require("../../../pages/hierarchy/erc1155/template/form");
const dialog_14 = require("../../../buttons/mechanics/collection/upload/dialog");
const dialog_15 = require("../../../buttons/mechanics/collection/deploy/dialog");
const dialog_16 = require("../../../buttons/mechanics/dispenser/upload/dialog");
const dialog_17 = require("../../../pages/mechanics/marketing/dispenser/main/allowance/dialog");
const form_10 = require("../../../pages/mechanics/marketing/wait-list/contract/form");
const dialog_18 = require("../../../buttons/common/allowance/dialog");
const dialog_19 = require("../../../buttons/common/top-up/dialog");
const form_11 = require("../../../pages/mechanics/marketing/wait-list/list/form");
const form_12 = require("../../../pages/mechanics/marketing/wait-list/item/form");
const dialog_20 = require("../../../buttons/mechanics/claim/upload/dialog");
const form_13 = require("../../../pages/mechanics/marketing/claim/template/form");
const form_14 = require("../../../pages/mechanics/marketing/claim/token/form");
const form_15 = require("../../../pages/mechanics/gaming/discrete/main/form");
const form_16 = require("../../../pages/mechanics/marketing/staking/contract/form");
const dialog_21 = require("../../../buttons/mechanics/staking/deploy/dialog");
const dialog_22 = require("../../../buttons/mechanics/staking/withdraw-penalty/dialog");
const dialog_23 = require("../../../buttons/mechanics/staking/check-balances/dialog");
const form_17 = require("../../../pages/mechanics/marketing/staking/rules/form");
const upload_dialog_1 = require("../../../buttons/mechanics/staking/upload/upload-dialog");
const dialog_24 = require("../../../buttons/mechanics/wait-list/list/upload/dialog");
const dialog_25 = require("../../../buttons/integrations/chain-link/add-subscription/dialog");
const dialog_26 = require("../../../buttons/integrations/chain-link/fund/dialog");
const dialog_27 = require("../../../buttons/mechanics/breed/breed-limits/dialog");
const dialog_28 = require("../../../buttons/mechanics/loot/box/mint/dialog");
const form_18 = require("../../../pages/infrastructure/profile/adresses/form");
const Empty = () => null;
exports.globalDialogComponentsSchema = {
    [types_1.GlobalDialogKeys.DEFAULT]: Empty,
    [types_1.GlobalDialogKeys.GRANT_ROLE]: dialog_6.AccessControlGrantRoleDialog,
    [types_1.GlobalDialogKeys.ACCOUNT]: account_1.AccountDialog,
    [types_1.GlobalDialogKeys.ADDRESS]: form_18.AddressDialog,
    [types_1.GlobalDialogKeys.ALLOWANCE]: dialog_18.AllowanceDialog,
    [types_1.GlobalDialogKeys.ADD_ETH_LISTENER]: dialog_3.EthListenerAddDialog,
    [types_1.GlobalDialogKeys.REMOVE_ETH_LISTENER]: dialog_4.EthListenerRemoveDialog,
    [types_1.GlobalDialogKeys.CONTRACT_ALLOWANCE]: dialog_8.ContractAllowanceDialog,
    [types_1.GlobalDialogKeys.ROYALTY]: dialog_1.RoyaltyEditDialog,
    [types_1.GlobalDialogKeys.TRANSFER]: dialog_2.TransferDialog,
    [types_1.GlobalDialogKeys.CONTRACT_MINT]: dialog_5.MintTokenDialog,
    [types_1.GlobalDialogKeys.SET_BASE_TOKEN_URI]: dialog_10.BaseTokenURIDialogForm,
    [types_1.GlobalDialogKeys.SET_CHAIN_LINK_SUBSCRIPTION]: dialog_11.ChainLinkSetSubscriptionDialog,
    [types_1.GlobalDialogKeys.TEMPLATE_MINT]: dialog_5.MintTokenDialog,
    [types_1.GlobalDialogKeys.COLLECTION_UPLOAD]: dialog_14.CollectionUploadDialog,
    [types_1.GlobalDialogKeys.DISPENSER_UPLOAD]: dialog_16.DispenserUploadDialog,
    [types_1.GlobalDialogKeys.DISPENSER_ALLOWANCE]: dialog_17.DispenserAllowanceDialog,
    [types_1.GlobalDialogKeys.TOP_UP]: dialog_19.TopUpDialog,
    [types_1.GlobalDialogKeys.CLAIM_UPLOAD]: dialog_20.ClaimUploadDialog,
    [types_1.GlobalDialogKeys.STAKING_WITHDRAW_PENALTY]: dialog_22.StakingWithdrawPenaltyDialog,
    [types_1.GlobalDialogKeys.STAKING_CHECK_BALANCE]: dialog_23.StakingCheckBalanceDialog,
    [types_1.GlobalDialogKeys.CHAIN_LINK_ADD_CUSTOMER_DIALOG_KEY]: dialog_25.ChainLinkSubscriptionDialog,
    [types_1.GlobalDialogKeys.CHAIN_LINK_FUND_SUBSCRIPTION_DIALOG_KEY]: dialog_26.ChainLinkFundDialog,
    [types_1.GlobalDialogKeys.ERC_20_CONTRACT_CREATE]: form_1.Erc20ContractDialogForm,
    [types_1.GlobalDialogKeys.ERC_20_CONTRACT_EDIT]: form_1.Erc20ContractDialogForm,
    [types_1.GlobalDialogKeys.ERC20_CONTRACT_DEPLOY]: dialog_7.Erc20ContractDeployDialog,
    [types_1.GlobalDialogKeys.NATIVE_CONTRACT_CREATE]: form_2.NativeTokenDialogForm,
    [types_1.GlobalDialogKeys.NATIVE_CONTRACT_EDIT]: form_2.NativeTokenDialogForm,
    [types_1.GlobalDialogKeys.ERC721_CONTRACT_CREATE]: form_3.Erc721ContractDialogForm,
    [types_1.GlobalDialogKeys.ERC721_CONTRACT_EDIT]: form_3.Erc721ContractDialogForm,
    [types_1.GlobalDialogKeys.ERC721_CONTRACT_DEPLOY]: dialog_9.Erc721ContractDeployDialog,
    [types_1.GlobalDialogKeys.ERC721_TEMPLATE_CREATE]: form_4.Erc721TemplateDialogForm,
    [types_1.GlobalDialogKeys.ERC721_TEMPLATE_EDIT]: form_4.Erc721TemplateDialogForm,
    [types_1.GlobalDialogKeys.ERC721_TOKEN_VIEW]: pages_1.Erc721TokenDialogView,
    [types_1.GlobalDialogKeys.ERC998_CONTRACT_EDIT]: form_5.Erc998ContractDialogForm,
    [types_1.GlobalDialogKeys.ERC998_CONTRACT_DEPLOY]: dialog_12.Erc998ContractDeployDialog,
    [types_1.GlobalDialogKeys.ERC998_TEMPLATE_CREATE]: form_6.Erc998TemplateDialogForm,
    [types_1.GlobalDialogKeys.ERC998_TEMPLATE_EDIT]: form_6.Erc998TemplateDialogForm,
    [types_1.GlobalDialogKeys.ERC998_TOKEN_VIEW]: view_1.Erc998TokenDialogView,
    [types_1.GlobalDialogKeys.ERC998_TOKEN_WITHDRAW]: withdraw_dialog_1.BalanceWithdrawDialog,
    [types_1.GlobalDialogKeys.ERC998_COMPOSITION_CREATE]: form_7.Erc998CompositionDialogForm,
    [types_1.GlobalDialogKeys.ERC998_COMPOSITION_VIEW]: view_2.Erc998CompositionDialogView,
    [types_1.GlobalDialogKeys.ERC1155_CONTRACT_CREATE]: form_8.Erc1155ContractDialogForm,
    [types_1.GlobalDialogKeys.ERC1155_CONTRACT_EDIT]: form_8.Erc1155ContractDialogForm,
    [types_1.GlobalDialogKeys.ERC1155_CONTRACT_DEPLOY]: dialog_13.Erc1155ContractDeployDialog,
    [types_1.GlobalDialogKeys.ERC1155_TEMPLATE_CREATE]: form_9.Erc1155TemplateDialogForm,
    [types_1.GlobalDialogKeys.ERC1155_TEMPLATE_EDIT]: form_9.Erc1155TemplateDialogForm,
    [types_1.GlobalDialogKeys.WAITLIST_CONTRACT_EDIT]: form_10.WaitListDialogForm,
    [types_1.GlobalDialogKeys.WAITLIST_LIST_CREATE]: form_11.WaitListListDialogForm,
    [types_1.GlobalDialogKeys.WAITLIST_LIST_EDIT]: form_11.WaitListListDialogForm,
    [types_1.GlobalDialogKeys.WAITLIST_ITEM_CREATE]: form_12.WaitListItemDialogForm,
    [types_1.GlobalDialogKeys.WAITLIST_LIST_CREATE_BUTTON]: form_12.WaitListItemDialogForm,
    [types_1.GlobalDialogKeys.WAITLIST_LIST_UPLOAD]: dialog_24.WaitListUploadDialog,
    [types_1.GlobalDialogKeys.CLAIM_TEMPLATE_CREATE]: form_13.ClaimTemplateDialogForm,
    [types_1.GlobalDialogKeys.CLAIM_TEMPLATE_EDIT]: form_13.ClaimTemplateDialogForm,
    [types_1.GlobalDialogKeys.CLAIM_TOKEN_CREATE]: form_14.ClaimTokenDialogForm,
    [types_1.GlobalDialogKeys.CLAIM_TOKEN_EDIT]: form_14.ClaimTokenDialogForm,
    [types_1.GlobalDialogKeys.LOOT_BOX_MINT_DIALOG_KEY]: dialog_28.LootBoxMintDialog,
    [types_1.GlobalDialogKeys.DISCRETE_CREATE]: form_15.GradeDialogForm,
    [types_1.GlobalDialogKeys.DISCRETE_EDIT]: form_15.GradeDialogForm,
    [types_1.GlobalDialogKeys.BREED_LIMIT_DIALOG_KEY]: dialog_27.BreedLimitDialog,
    [types_1.GlobalDialogKeys.STAKING_CONTRACT_EDIT]: form_16.StakingDialogForm,
    [types_1.GlobalDialogKeys.STAKING_CONTRACT_DEPLOY]: dialog_21.StakingDeployDialog,
    [types_1.GlobalDialogKeys.STAKING_RULE_EDIT]: form_17.StakingRuleDialogForm,
    [types_1.GlobalDialogKeys.STAKING_RULE_CREATE]: upload_dialog_1.StakingRuleUploadDialog,
    [types_1.GlobalDialogKeys.COLLECTIONS_CONTRACT_DEPLOY]: dialog_15.CollectionContractDeployDialog,
};
function renderComponent(externalDialogComponentSchema, key, props) {
    const C = { ...exports.globalDialogComponentsSchema, ...externalDialogComponentSchema }[key];
    return react_1.default.createElement(C, props);
}
//# sourceMappingURL=index.js.map